import { createContext, useContext, useState, useEffect } from 'react';
import translations from './index';

const LanguageContext = createContext(null);

export const LANGUAGES = [
  { code: 'ar', label: 'العربية', dir: 'rtl' },
  { code: 'fr', label: 'Français', dir: 'ltr' },
  { code: 'en', label: 'English', dir: 'ltr' },
];

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    return localStorage.getItem('bmh_lang') || 'ar';
  });

  const dir = lang === 'ar' ? 'rtl' : 'ltr';

  useEffect(() => {
    document.documentElement.dir = dir;
    document.documentElement.lang = lang;
    localStorage.setItem('bmh_lang', lang);
  }, [lang, dir]);

  const setLang = (code) => setLangState(code);

  // Translate with optional variable interpolation: t('cart.itemsCount', { count: 3 })
  const t = (key, vars = {}) => {
    const keys = key.split('.');
    let result = translations[lang];
    for (const k of keys) {
      result = result?.[k];
    }
    if (Array.isArray(result)) return result;
    if (typeof result !== 'string') return key;
    return Object.entries(vars).reduce(
      (str, [k, v]) => str.replace(`{${k}}`, v),
      result
    );
  };

  // Picks the correct language field from a multilingual object { ar, en, fr }
  const getLabel = (obj) => obj?.[lang] || obj?.ar || obj?.en || obj?.fr || '';

  return (
    <LanguageContext.Provider value={{ lang, setLang, dir, t, getLabel, LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
};
